import { OPERATOR_FLOW } from '../operator/operatorConstants';
import { fetchPutawayRow, scanPutawayCode, storePutaway } from './operatorPutawayThunks';
import { storeMessage } from './operatorPutawayUtils';

/** What the band says for each putaway outcome; see `operatorListeners`. */
export const PUTAWAY_SIGNAL_RULES = {
  // The row a task opened shows itself; one stored meanwhile leaves the list to choose from.
  [fetchPutawayRow.typePrefix]: {
    success: ({ payload }) =>
      payload ? null : { tone: 'warning', message: 'Eso ya está guardado: elige otra fila de la lista.' },
  },
  [scanPutawayCode.typePrefix]: {
    success: ({ payload }) => {
      if (payload.kind === 'row') return { tone: 'step', message: 'Escanea dónde lo guardas.' };
      if (payload.kind === 'destination') {
        const { name, code, suggested } = payload.destination;
        return suggested
          ? { tone: 'step', message: `${name || code}: es la sugerida.` }
          : { tone: 'warning', message: `${name || code} no es la sugerida; puedes guardar igual.` };
      }
      return { tone: 'warning', message: 'Hay más de una fila de ese producto: elige cuál.' };
    },
  },
  [storePutaway.typePrefix]: {
    success: ({ payload, meta }) => storeMessage(payload, meta.arg),
    retry: OPERATOR_FLOW.PUTAWAY,
  },
};
